import { render, staticRenderFns } from "./CategoryBar.vue?vue&type=template&id=54200a9a&"
import script from "./CategoryBar.vue?vue&type=script&lang=js&"
export * from "./CategoryBar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports